import { h } from '@qiov/logicflow-core'
import BaseNode from './BaseNode'

class RainNode extends BaseNode.view {
  getIcon() {
    const {
      width,
      height
    } = this.props.model
    return h('image', {
      width: 30,
      height: 36,
      x: -width / 2 + 4,
      y: -height / 2,
      href: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/icon/Rain.svg'
    })
  }
}

class RainNodeModel extends BaseNode.model {
  initNodeData(data) {
    super.initNodeData(data)
    this.width = 200
    this.height = 36
    this.defaultFill = 'rgb(135, 206, 234)'
  }
  getData() {
    const data = super.getData()
    data.properties.class = 'Rain'
    return data
  }
}

export default {
  type: 'Rain-node',
  model: RainNodeModel,
  view: RainNode
}
